import { Node, Transforms } from 'slate';
import { HistoryEditor } from 'slate-history';
import * as serializer from 'basic-editor-value-serializer';

const icon = serializer.utilities.node.icon;

export function read(editor, path) {
  return icon.readSettings(Node.get(editor, path));
}

export function write(editor, path, changes) {
  const node = Node.get(editor, path);
  const settings = icon.sanitizeSettings({ ...icon.readSettings(node), ...changes }, icon.isAttached(node));
  if (JSON.stringify(settings) === JSON.stringify(node.properties.icon)) {
    return;
  }
  HistoryEditor.withNewBatch(editor, function saveIcon() {
    Transforms.setNodes(editor, { properties: { ...node.properties, icon: settings } }, { at: path });
  });
}

export function remove(editor, path) {
  const node = Node.get(editor, path);
  if (icon.isAttached(node) === false || icon.readSettings(node) === null) {
    return;
  }
  HistoryEditor.withNewBatch(editor, function removeIcon() {
    const properties = { ...node.properties };
    delete properties.icon;
    Transforms.setNodes(editor, { properties }, { at: path });
  });
}
